module.exports = __webpack_public_path__ + "img/0f02a32.jpg";